import { render, staticRenderFns } from "./ThreadForm.vue?vue&type=template&id=58f53567"
import script from "./ThreadForm.vue?vue&type=script&lang=js"
export * from "./ThreadForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../client/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports